import styled from "styled-components";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { theme } from "@/styles/theme";
import { media } from "@/styles/media";
import { IFontProps } from "@/typings/Props";
import Header from "@/components/main/Header";
import Timeline from "@/components/learn/Timeline";
import Footer from "@/components/main/Footer";

export default function Home() {
  const { t } = useTranslation();
  return (
    <>
      <Header />
      <ContentWrapper>
        <MainContent>
          <P $fontSize="1.8rem" $fontWeight={theme.fontWeights.bold} $lineHeight="200%">
            {t("learn.about-us.about-inbody")}
          </P>
          <P
            id="title"
            $fontSize="3.3rem"
            $fontWeight={theme.fontWeights.bold}
            $fontColor={theme.colors.primary}
            $lineHeight="120%"
            $marginTop="30px"
          >
            {t("learn.about-us.main-title")}
          </P>
          <MainDescWrapper>
            <MainDesc>{t("learn.about-us.main-desc-1")}</MainDesc>
            <MainDesc>{t("learn.about-us.main-desc-2")}</MainDesc>
          </MainDescWrapper>
          <LinkButton href="https://youtu.be/AQHyoQJR07A?feature=shared" target="_blank">
            {t("learn.about-us.watch-inbody-in-action")}
          </LinkButton>
        </MainContent>
      </ContentWrapper>
      <ContentWrapper>
        <Bg $bg={"/learn/about-us/inbody-factory.png"}>
          <DescBoxWrapper>
            <DescBox $bgColor={theme.colors.background.white} $width="403px">
              <P
                $fontSize="2rem"
                $fontColor={theme.colors.primary}
                $fontWeight="700"
                data-aos="fade-up"
                data-aos-easing="ease-out"
                data-aos-duration="500"
              >
                {t("learn.mission")}
              </P>
              <P
                $marginTop="30px"
                $fontColor={theme.colors.text.grayLight}
                $lineHeight="150%"
                data-aos="fade-up"
                data-aos-easing="ease-out"
                data-aos-duration="500"
              >
                {t("learn.mission.desc")}
              </P>
            </DescBox>
            <DescBox $bgColor={theme.colors.background.white} $width="403px">
              <P
                $fontSize="2rem"
                $fontColor={theme.colors.primary}
                $fontWeight={theme.fontWeights.bold}
                data-aos="fade-up"
                data-aos-easing="ease-out"
                data-aos-duration="500"
              >
                {t("learn.vision")}
              </P>
              <P
                $marginTop="30px"
                $fontColor={theme.colors.text.grayLight}
                $lineHeight="150%"
                data-aos="fade-up"
                data-aos-easing="ease-out"
                data-aos-duration="500"
              >
                {t("learn.vision.desc")}
              </P>
            </DescBox>
          </DescBoxWrapper>
        </Bg>
      </ContentWrapper>
      <CompoanyValueWrapper>
        <TitleWrapper>
          <P $fontSize="2rem" $fontWeight={theme.fontWeights.bold} $textAlign="center" $marginTop="50px">
            {t("learn.company-values")}
          </P>
          <P
            $fontSize="3rem"
            $fontWeight={theme.fontWeights.bold}
            $textAlign="center"
            $fontColor={theme.colors.primary}
            $lineHeight="180%"
          >
            {t("learn.our-guiding-principles")}
          </P>
        </TitleWrapper>
        <CompanyAreaWrapper>
          <CompanyArea id="cvImgArea">
            <Bg
              id="cvImg"
              $bg="/main/header/super-high-1030x634.jpg"
              $borderRadius="20px"
              data-aos="fade-right"
              data-aos-easing="ease-out"
              data-aos-delay="100"
              data-aos-duration="500"
            />
          </CompanyArea>
          <CompanyArea id="cvContentArea">
            <DescBox
              className="cv"
              $bgColor="#ededed"
              $width="45%"
              data-aos="fade-up"
              data-aos-easing="ease-out"
              data-aos-delay="100"
              data-aos-duration="400"
            >
              <P
                $fontSize="2rem"
                $fontColor={theme.colors.text.grayDark}
                $fontWeight={theme.fontWeights.bold}
                $lineHeight="170%"
              >
                {t("learn.education")}
              </P>
              <P $fontColor={theme.colors.text.grayLight} $lineHeight="150%">
                {t("learn.education.desc")}
              </P>
            </DescBox>
            <DescBox
              className="cv"
              $bgColor="#ededed"
              $width="45%"
              data-aos="fade-up"
              data-aos-easing="ease-out"
              data-aos-delay="200"
              data-aos-duration="400"
            >
              <P
                $fontSize="2rem"
                $fontColor={theme.colors.text.grayDark}
                $fontWeight={theme.fontWeights.bold}
                $lineHeight="170%"
              >
                {t("learn.motivation")}
              </P>
              <P $fontColor="#676767" $lineHeight="150%">
                {t("learn.motivation.desc")}
              </P>
            </DescBox>
            <DescBox
              className="cv"
              $bgColor="#ededed"
              $width="45%"
              data-aos="fade-up"
              data-aos-easing="ease-out"
              data-aos-delay="100"
              data-aos-duration="400"
            >
              <P
                $fontSize="2rem"
                $fontColor={theme.colors.text.grayDark}
                $fontWeight={theme.fontWeights.bold}
                $lineHeight="170%"
              >
                {t("learn.innovation")}
              </P>
              <P $fontColor={theme.colors.text.grayLight} $lineHeight="150%">
                {t("learn.innovation.desc")}
              </P>
            </DescBox>
            <DescBox
              className="cv"
              $bgColor="#ededed"
              $width="45%"
              data-aos="fade-up"
              data-aos-easing="ease-out"
              data-aos-delay="200"
              data-aos-duration="400"
            >
              <P $fontSize="2rem" $fontColor={theme.colors.text.grayDark} $fontWeight="700" $lineHeight="170%">
                {t("learn.application")}
              </P>
              <P $fontColor={theme.colors.text.grayLight} $lineHeight="150%">
                {t("learn.application.desc")}
              </P>
            </DescBox>
          </CompanyArea>
        </CompanyAreaWrapper>
      </CompoanyValueWrapper>
      <AwardWrapper>
        <TitleWrapper id="awardTitle">
          <P $fontSize="2rem" $fontWeight={theme.fontWeights.bold} $textAlign="center" $marginTop="50px">
            {t("learn.award-winning")}
          </P>
          <P
            $fontSize="2.8rem"
            $fontWeight={theme.fontWeights.bold}
            $textAlign="center"
            $fontColor={theme.colors.primary}
            $lineHeight="155%"
          >
            {t("learn.celebrating-our-achievements")}
          </P>
        </TitleWrapper>
        <Awards>
          <AwardItem>
            <AwardImg src="/learn/about-us/reddot_award.png" alt="award-img1" />
          </AwardItem>
          <AwardItem>
            <AwardImg src="/learn/about-us/design_award.png" alt="award-img2" />
          </AwardItem>
          <AwardItem>
            <AwardImg src="/learn/about-us/Screenshot_2024-04-05_at_16.19.05-removebg-preview.png" alt="award-img3" />
          </AwardItem>
          <AwardItem>
            <AwardImg src="/learn/about-us/ces_2017.png" alt="award-img4" />
          </AwardItem>
          <AwardItem>
            <AwardImg src="/learn/about-us/ces_2020.png" alt="award-img5" />
          </AwardItem>
          <AwardItem>
            <AwardImg src="/learn/about-us/ces_2024.png" alt="award-img6" />
          </AwardItem>
        </Awards>
      </AwardWrapper>
      <FounderWrapper>
        <FounderImage src="/learn/about-us/Kichul_Cha_Banner.jpg" alt="founder-image" />
        <FounderDescWrapper>
          <FounderArea $width="80%">
            <P className=" founderTitle" $fontSize="1.5rem">
              {t("learn.founder-message")}
            </P>
            <P
              className="founderName founderTitle"
              $fontSize="3rem"
              $fontWeight={theme.fontWeights.bold}
              $fontColor={theme.colors.primary}
              $lineHeight="155%"
            >
              {t("learn.dr-kichul-cha")}
            </P>
          </FounderArea>
          <FounderArea>
            <P $fontColor={theme.colors.text.grayLight} $lineHeight="150%">
              {t("learn.dr-kichul-cha.message")}
            </P>
          </FounderArea>
        </FounderDescWrapper>
      </FounderWrapper>
      <Timeline tab="aboutUs">{t("learn.timeline.inbody-history")}</Timeline>
      <Footer />
    </>
  );
}

// main
const MainContent = styled.div`
  width: 75%;
  height: 600px;
  margin-top: 100px;
  margin: 100px auto;
  ${media.tablet`
    height: initial;
    padding: 30px 20px 0 20px;
    margin: auto;
    `}
`;
const MainDescWrapper = styled.div`
  width: 100%;
  margin-top: 70px;
  margin-bottom: 50px;
  display: flex;
  justify-contet: space-between;
  ${media.tablet`
    flex-wrap: wrap;
  `}
`;
const MainDesc = styled.p`
  width: 550px;
  line-height: 150%;
  white-space: pre-wrap;
  margin: 0 60px 0 0;
  color: ${theme.colors.text.grayLight};
`;

const LinkButton = styled(Link)`
  border-radius: 30px;
  padding: 13px 20px;
  font-size: 1rem;
  cursor: pointer;
  background-color: ${theme.colors.button.black};
  transition: ease-out 0.3s;
  color: ${theme.colors.text.white};
  &:hover {
    transition: ease-out 0.3s;
    background-color: ${theme.colors.primary};
  }
`;

// vision
const Bg = styled.div<{ $bg: string; $borderRadius?: string }>`
  position: relative;
  width: 100%;
  height: 100%;
  background: url(${({ $bg }) => $bg});
  background-size: cover;
  background-position-x: 50%;
  border-radius: ${({ $borderRadius }) => $borderRadius};
  @media (max-width: 600px) {
    &#cvImg {
      background-repeat: no-repeat;
    }
  }
`;

const DescBoxWrapper = styled.div`
  position: absolute;
  bottom: 70px;
  left: 0;
  width: 100%;
  height: 274px;
  display: flex;
  padding: 5px 30px;
  @media (max-width: 750px) {
    flex-wrap: wrap;
    bottom: 350px;
    padding: 20px;
  }
`;

// company Values
const CompoanyValueWrapper = styled.div`
  width: 100%;
  height: 870px;
  margin-top: 100px;

  ${media.desktopMid`
    flex-wrap: wrap;
    height: 1450px;
  `}
  @media (max-width: 750px) {
    height: 1750px;
  }
`;
const CompanyAreaWrapper = styled.div`
  width: 100%;
  height: 670px;
  display: flex;
  flex-wrap: wrap;
`;
const CompanyArea = styled.div`
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  ${media.desktopMid`
    &#cvImgArea {
      height: 50%;
    }
    width: 100%;
  `}
`;
// Awards
const AwardWrapper = styled.div`
  width: 100%;
  height: 550px;
  margin-top: 100px;
`;
const Awards = styled.div`
  width: 100%;
  height: 200px;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  ${media.tablet`
    flex-wrap: wrap;
  `}
`;
const AwardItem = styled.div`
  margin: 10px;
  width: 170px;
  height: 170px;
  background-color: ${theme.colors.background.white};
  border-radius: 20px;
  ${media.tablet`
    width: 130px;
    height: 130px;
  `}
  ${media.mobile`
    width: 100px;
    height: 100px;
  `}
  ${media.mini`
    width: 80px;
    height: 80px;
  `}
`;
const AwardImg = styled.img`
  width: 100%;
  height: 100%;
  padding: 10px;
  object-fit: contain;
`;

// founder message
const FounderWrapper = styled.div`
  width: 93%;
  height: 880px;
  margin: auto;
  ${media.desktopMid`
    height: auto;
  `}
`;
const FounderImage = styled.img`
  width: 100%;
  height: 70%;
  border-radius: 10px;
  object-fit: cover;
`;
const FounderDescWrapper = styled.div`
  width: 100%;
  height: 254px;
  padding: 40px 70px;
  display: flex;
  ${media.desktopMid`
    height: auto;
    flex-wrap: wrap;
  `}
`;
const FounderArea = styled.div<{ $width?: string }>`
  width: ${({ $width }) => $width};
  height: 100%;
  ${media.desktopMid`
    width: 100%;
  `}
`;

// common
const ContentWrapper = styled.div`
  width: 100%;
  height: 953px;
  ${media.phablet`
    height: 1300px;
  `}
  ${media.desktopMid` 
    &#cvWrapper {
      height: 1600px;
    }
    &#timelineWrapper {
      margin-top: 30%;
    }
  `}
`;
const TitleWrapper = styled.div`
  width: 100%;
  height: 200px;
  &#awardTitle {
    padding: 20px;
  }
`;
const P = styled.p<IFontProps>`
  font-size: ${(props) => props.$fontSize};
  font-weight: ${(props) => props.$fontWeight};
  line-height: ${(props) => props.$lineHeight};
  color: ${(props) => props.$fontColor};
  margin-top: ${(props) => props.$marginTop};
  margin-right: ${(props) => props.$marginRight};
  text-align: ${(props) => props.$textAlign};
  white-space: pre-wrap;
  @media (max-width: 1300px) {
    &#title {
      font-size: 2.5rem;
    }
  }
  @media (max-width: 1000px) {
    &.founderName {
      font-size: 2.3rem;
    }
    &.founderTitle {
      text-align: center;
    }
  }
`;
const DescBox = styled.div<{ $bgColor: string; $width: string }>`
  width: ${({ $width }) => $width};
  height: auto;
  padding: 37px;
  background-color: ${({ $bgColor }) => $bgColor};
  border-radius: 20px;
  margin: 10px;
  transition: ease-out 0.3s;
  @media (max-width: 1340px) {
    &.cv {
      width: 100%;
    }
  }
  @media (max-width: 1000px) {
    width: 100%;
  }
  @media (max-width: 750px) {
    margin-bottom: 20px;
  }
  &.cv:hover {
    transition: ease-out 0.3s;
    background-color: #676767;
    &.cv > P {
      color: white;
    }
  }
`;
